import { ActivityIndicator, View } from 'react-native'
import { Theme, ThemedView } from '@app/theme'
import ScreenWrapper from '@hoc/ScreenWrapper'
import { PrivateStackParamList } from '@routes/types'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import KeyboardDismissView from '@hoc/KeyboardDismissView'
import CommonHeader from '@sharedComponents/Header/Header'
import Stepper from '@sharedComponents/Stepper/Stepper'
import { useStepperData } from '@hooks/useStepperData'
import { useTheme } from '@shopify/restyle'
import { useAppSelector } from '@store/hooks'
import { LENDER_ID } from '@types/regix'
import DSPAdditonalDetailsForm from '@screens/KYC/KYCAdditionalDetails/components/DSPAdditonalDetailsForm'
import TataAdditonalDetailsForm from '@screens/KYC/KYCAdditionalDetails/components/TataAdditionalForm'
import { getAdditionalDetailsApi } from './kycAdditonalDetailsService'
import { useEffect, useState } from 'react'
import { useAppDispatch } from '@store/hooks'
import { showErrorSheet } from '@store/slices/errorSlice'
import { ThemedTouchableOpacity } from '@app/theme/Components'
import { ScrollView } from 'react-native-gesture-handler'





type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'KYC_ADDITIONAL_DETAILS'>

const KycAdditonalDetails = ({ navigation, route }: ScreenProps) => {

    const { stepperData, isLoading: isStepperLoading } = useStepperData()

    const { colors } = useTheme<Theme>()
    const dispatch = useAppDispatch()
    const userDetails = useAppSelector(state => state.auth.userDetails);
    const isLenderDSP = userDetails?.linkedApplications[0]?.lenderAccountId?.toLowerCase() === LENDER_ID.DSP;
    const [additionalDetails, setAdditionalDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        // setIsLoading(true)
        getAdditionalDetailsApi({
            applicationId: userDetails?.linkedApplications[0]?.applicationId
        }).then((res) => {
            setAdditionalDetails(res.data)
        }).catch((err) => {
            dispatch(showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: err?.data?.message,
                closeOnBackdropPress: true,
                errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            }));
        }).finally(() => {
            // setIsLoading(false)
        })
    }, [])

    //  return(
    //            <ScrollView contentContainerStyle={{flexGrow: 1}}>
    //                {new Array(100).fill(0).map((e,l) => (
    //                 // <ThemedText>{l+1}</ThemedText>
    //                 <View style={{height : 40 , backgroundColor : l % 2 === 0 ? 'red' : 'blue' , marginBottom :10}} />
    //                ))}
    //             </ScrollView>
    //     )


    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            {/* <KeyboardDismissView> */}
                <ThemedView flex={1}
                    bg='bg-surface-primary'
                >
                    <CommonHeader
                        navigation={navigation}
                        pageName={route.name}
                        showNeedHelp={true}
                        hideBottomBorder={true}
                        label='KYC verification'
                    />
                    <Stepper isLoading={isStepperLoading} stepperData={stepperData} />
                    {isLenderDSP ? <DSPAdditonalDetailsForm navigation={navigation} additionalDetails={additionalDetails} /> : <TataAdditonalDetailsForm navigation={navigation} additionalDetails={additionalDetails} />}
                </ThemedView>
            {/* </KeyboardDismissView> */}
        </ScreenWrapper>
    )
}

export default KycAdditonalDetails